import {
    SET_CALL_RESULT_TIMER,
    SET_RESULT_POPUP_VISIBILITY,
    SET_RESULT_POPUP_VISIBILITY_ON_LOAD,
    WINDOW_ON_LOAD,
    TOGGLE_TRANSCRIPT,
    TOGGLE_TRANSCRIPT_COPY_BUTTON,
    SET_TRANSCRIPT_COPY_BUTTON_AVAILABILITY,
    COPY_TO_CLIPBOARD,
    HIDE_NEW_CALL_MESSAGE,
    RESUME_TRAINER,
    SEND_MANUAL_CALL_EVENT,
    SET_MANUAL_BUTTON_AVAILABILITY,
    SNOOZE_TRAINER,
    ADD_SNOOZE_TIMER,
    USER_RELOAD,
    SET_INFINITY_SNOOZE,
    MANUAL_OPT_IN,
    MANUAL_OPT_STOP,
    MANUAL_OPT_OUT,
    INIT,
    SAVE_CONVERSION,
    AUDIO_DEVICE_RELOAD
} from './actionTypes/trainer';
import { HIDE_CONVERSION_MODAL } from './actionTypes/conversion';
import { reload } from './backendCommon';
import { setSnoozeTimer, types as snoozeTypes } from './backendSnooze';
import { INFINITY_SNOOZE_SEC } from '../../constants/backend';
import { types as callTypes, saveConversion as saveConversionRequest } from './backendCall';
import type { RootState } from '../types';
import type { ConversionPayload } from '../../components/Trainer/Conversion/TrainerConversion';

type DispatchFn = (action: unknown) => unknown;
type GetState = () => RootState;

const setResultPopupVisibility = (isVisible: boolean) => ({
    type: SET_RESULT_POPUP_VISIBILITY,
    payload: {
        isCallResultVisible: isVisible
    }
});

const setResultPopupVisibilityOnLoad = () => ({
    type: SET_RESULT_POPUP_VISIBILITY_ON_LOAD
});

const setCallResultTimer = () => ({
    type: SET_CALL_RESULT_TIMER
});

const windowOnLoad = () => ({
    type: WINDOW_ON_LOAD
});

const init = () => ({ type: INIT });

const toggleTranscript = (isVisible: boolean) => ({
    type: TOGGLE_TRANSCRIPT,
    payload: { isVisible }
});

const onTranscriptCopyButtonClick = () => ({
    type: TOGGLE_TRANSCRIPT_COPY_BUTTON
});

const setTranscriptCopyButtonAvailability = (copyEnabled: boolean) => ({
    type: SET_TRANSCRIPT_COPY_BUTTON_AVAILABILITY,
    payload: { copyEnabled }
});

const copyToClipboard = (payload: string) => ({
    type: COPY_TO_CLIPBOARD,
    payload
});

const hideNewCallMessage = () => ({
    type: HIDE_NEW_CALL_MESSAGE
});

const resumeTrainer = () => ({
    type: RESUME_TRAINER
});

const onManualCallEvent = (isStart: boolean) => (dispatch: DispatchFn) => {
    dispatch({
        type: SEND_MANUAL_CALL_EVENT,
        payload: {
            isStart
        }
    });
    dispatch({
        type: callTypes.SEND_MANUAL_CALL_EVENT,
        payload: { isStart: Boolean(isStart) }
    });
};

const changeCallButtonAvailability = (isAvailable: boolean) => ({
    type: SET_MANUAL_BUTTON_AVAILABILITY,
    payload: {
        isAvailable
    }
});

const snoozeTrainer = (snoozeFor: number) => (dispatch: DispatchFn, getState: GetState) => {
    dispatch({
        type: SNOOZE_TRAINER,
        payload: { snoozeFor }
    });

    if (getState().trainer.isTrainerActive) {
        dispatch({
            type: snoozeTypes.SNOOZE_TRAINER,
            payload: { snoozeFor: Number(snoozeFor) || 0 }
        });
    }
};

const addSnoozeTimer = (snoozeFor: number) => (dispatch: DispatchFn, getState: GetState) => {
    dispatch({
        type: ADD_SNOOZE_TIMER,
        payload: { snoozeFor }
    });
    const current = Number(getState().trainer.snoozeTimer) || 0;
    dispatch(setSnoozeTimer((Number(snoozeFor) || 0) + current));
};

export const setInfinitySnooze = () => (dispatch: DispatchFn) => {
    dispatch({
        type: SET_INFINITY_SNOOZE
    });
    dispatch(setSnoozeTimer(INFINITY_SNOOZE_SEC));
};

const userReload = () => (dispatch: DispatchFn) => {
    dispatch({
        type: USER_RELOAD
    });
    dispatch(
        reload({
            isImmediate: true,
            reason: 'USER_RELOAD'
        })
    );
};

const manualOptOut = () => (dispatch: DispatchFn) => {
    dispatch({ type: MANUAL_OPT_OUT });
    dispatch({ type: callTypes.OPT_OUT });
};

const manualOptIn = () => (dispatch: DispatchFn) => {
    dispatch({ type: MANUAL_OPT_IN });
    dispatch({ type: callTypes.OPT_IN });
};

const manualOptStop = () => (dispatch: DispatchFn) => {
    dispatch({ type: MANUAL_OPT_STOP });
    dispatch({ type: callTypes.OPT_STOP });
};

const saveConversion = (payload: ConversionPayload) => (dispatch: DispatchFn) => {
    dispatch({ type: SAVE_CONVERSION, payload });
    dispatch(saveConversionRequest(payload));
};

const closeConversionModal = () => ({ type: HIDE_CONVERSION_MODAL });
const audioDeviceReload = () => (dispatch: DispatchFn) => {
    dispatch({ type: AUDIO_DEVICE_RELOAD });
    dispatch(
        reload({
            isImmediate: true,
            reason: 'AUDIO_DEVICE_CHANGED'
        })
    );
};

export {
    setResultPopupVisibility,
    setResultPopupVisibilityOnLoad,
    setCallResultTimer,
    windowOnLoad,
    toggleTranscript,
    onTranscriptCopyButtonClick,
    setTranscriptCopyButtonAvailability,
    copyToClipboard,
    hideNewCallMessage,
    resumeTrainer,
    onManualCallEvent,
    changeCallButtonAvailability,
    snoozeTrainer,
    addSnoozeTimer,
    userReload,
    manualOptIn,
    manualOptOut,
    manualOptStop,
    init,
    saveConversion,
    closeConversionModal,
    audioDeviceReload
};
